import { Base } from '../../base/components/base'
import { ABSOLUTE, HIDE, SHOW, Y } from '../../base/helpers/style'
import { IRouteParams } from '../../base/lib/router'

const totalTransition = 160
export const PAGE_STYLE = {
    ...ABSOLUTE,
    ...Y(60),
    ...HIDE,
    backGroundColor: 'white',
    // paddingLeft: '65px',
    overflowY: 'hidden',
    overflowX: 'hidden',
    transition: `all ${totalTransition}ms cubic-bezier(0.16, 0.71, 0.58, 0.95)`,
    pointerEvents: 'none',
}

export const PAGE_ENTER_DEFAULT_STYLE = {
    ...SHOW,
    ...Y(0)
}
export const PAGE_EXIT_DEFAULT_STYLE = {
    ...HIDE,
    ...Y(60)
}
export const PAGE_EXIT_DEFAULT_UP_STYLE = {
    ...HIDE,
    ...Y(-60)
}